import {
  PinLockDelay,
  PinResetRequestResponse,
  PinStatus,
} from "../types/pin.definition";
import {
  requestChangePin,
  requestConfirmPinReset,
  requestCreatePin,
  requestPinReset,
  requestUnlockPin,
  requestUpdatePinLockDelay,
} from "../webclients/pin.client";

export const pinApi = {
  createPin: async (pin: string): Promise<PinStatus> =>
    (await requestCreatePin(pin)).data,

  unlock: async (pin: string): Promise<PinStatus> =>
    (await requestUnlockPin(pin)).data,

  changePin: async (currentPin: string, newPin: string): Promise<PinStatus> =>
    (await requestChangePin(currentPin, newPin)).data,

  requestReset: async (): Promise<PinResetRequestResponse> =>
    (await requestPinReset()).data,

  confirmReset: async (otp: string, newPin: string): Promise<PinStatus> =>
    (await requestConfirmPinReset(otp, newPin)).data,

  updateLockDelay: async (lockMinutes: number): Promise<PinLockDelay> =>
    (await requestUpdatePinLockDelay(lockMinutes)).data,
};
